import React, { useContext } from 'react';
import { ChoiceGroupProps } from '../types';

export type ContextProps<T> = Pick<ChoiceGroupProps<T>, 'value' | 'multiple' | 'size' | 'fill'> & {
    onItemClick: (newValue: T) => void;
};

const Context = React.createContext<ContextProps<any> | undefined>(undefined);

export const ChoiceGroupContext = Context.Provider;

export function useChoiceGroupContext<T>() {
    const context = useContext<ContextProps<T> | undefined>(Context);

    if (context === undefined) {
        throw new Error(`${useChoiceGroupContext.name} should be used only with ChoiceGroupContext`);
    }

    return context;
}
